module.exports = __webpack_public_path__ + "img/logo.206c94c8.png";